var SparePartsDashboard = function () {
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            fontWeight: "bold"
        }
    }, "Coming soon...");
};
export default SparePartsDashboard;
